import { useEffect, useState } from 'react';
import './Footer.css';
import updateTextFile from './updateText.json';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';

function Footer(props) {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    function handleToggle() {
        props.toggleBackgroundColor();
    }

    function handleMuteToggle() {
        props.setMuted(!props.muted);
    }

    useEffect(() => {
        setCurrentYear(new Date().getFullYear());
    }, [currentYear]);

    return (
        <div className='footer'>
            {props.isArchiveSelected && !props.showInformation &&
                <div style={{ flexBasis: '30%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                    <div>{props.swiperIndex + 1} / {props.folderSizes ? props.folderSizes.length : null}</div>
                    <div className={props.showDetails ? 'selected cursor-pointer item-margin-left' : 'item-margin-left cursor-pointer'} onClick={() => { props.setShowDetails(!props.showDetails); props.setShowContactInformation(false); props.setShowAbout(false); }}>{props.showDetails ? 'CLOSE' : 'DETAILS'}</div>
                </div>
            }
            {props.isTypefaceSelected && !props.showInformation &&
                <div style={{ flexBasis: '30%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                    <div>{props.typefaceSwiperIndex + 1} / {props.typefacesFolderSize}</div>
                    <div className={props.showDetails ? 'selected cursor-pointer item-margin-left' : 'item-margin-left cursor-pointer'} onClick={() => { props.setShowDetails(!props.showDetails); props.setShowContactInformation(false); props.setShowAbout(false); }}>{props.showDetails ? 'CLOSE' : 'DETAILS'}</div>
                </div>
            }
            <div className='flex'>
                <label className="switch">
                    <input type="checkbox" checked={props.typefaceBackground}
                        onChange={handleToggle} />
                    <span className="slider round"></span>
                </label>
            </div>
            <div style={{ flexBasis: '30%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                {props.isArchiveSelected && (
                    <div className='mute-icon' style={{ display: 'flex', alignItems: 'center', marginRight: '10%' }}>
                        {props.muted ? <FaVolumeMute style={{ cursor: 'pointer' }} onClick={handleMuteToggle} /> : <FaVolumeUp style={{ cursor: 'pointer' }} onClick={handleMuteToggle} />}
                    </div>
                )}
                <span className='whitespace-nowrap'>
                    {updateTextFile.updateText}
                </span>
            </div>
        </div >
    );
}

export default Footer;
